import { createReducerFromMap } from "@coverme/redux";
import { cloneDeep } from "lodash-es";

const initialState = [];

function isEmptyOrHasOnlyNulls(object, except = []) {
    if (Object.keys(object).length === 0 && object.constructor === Object) {
        return true;
    }

    for (const prop in object) {
        if (!object.hasOwnProperty(prop)) {
            continue;
        }

        if (except.indexOf(prop) > -1) {
            continue;
        }

        if (object[prop] != null) {
            return false;
        }
    }

    return true;
}

function areAllObjectsInArrayEmptyOrNull(sourceArray, except = []) {
    if (sourceArray == null) {
        return true;
    }

    if (sourceArray.length === 0) {
        return true;
    }

    for (const item of sourceArray) {
        if (!isEmptyOrHasOnlyNulls(item, except)) {
            return false;
        }
    }

    return true;
}

function updatePersonsInfoScreening(state, data) {
    return data.value.map(x => ({
        ...x,
        incomeInfo: buildIncomeInfo(x),
    }));
}

function resetInterview(state, action) {
    return initialState;
}

function getInterview(state, action) {
    const { value } = action;
    let newState = cloneDeep(state);

    if (
        value.personInfoScreenings &&
        value.personInfoScreenings.length > 0 &&
        areAllObjectsInArrayEmptyOrNull(value.personInfoScreenings, ["personId", "incomeInfo"]) === false
    ) {
        const updatedPersonInfoScreening = value.personInfoScreenings.map(x => {
            const isInitialized = x.planToFileTaxes != null;
            return {
                ...x,
                willFileJointly: x.planToFileTaxes === true ? x.filesJointlyWith != null : null,
                willBeClaimedAsDependent: isInitialized ? x.claimedAsADependentBy != null : null,
                income: {
                    ...state.income,
                    ...x.income,
                    employers: x.income.employers?.length > 0 ? x.income.employers : [{ frequency: "", amount: "" }],
                    hasUnearnedIncome: Object.keys(x.income.unearned || {}).length > 0,
                },
                incomeInfo: buildIncomeInfo(x),
                /*incomeInfo: {
                    ...x.incomeInfo,
                    doesReceiveIncome: isInitialized ? x.incomeInfo.doesReceiveIncome === true : null,
                },*/
            };
        });
        newState = updatePersonsInfoScreening(newState, { value: updatedPersonInfoScreening });
    }

    return newState;
}

export const personInfoScreeningReducer = createReducerFromMap(initialState, {
    UPDATE_PERSONS_INFO_SCREENING_COMPLETE: updatePersonsInfoScreening,
    RESET_INTERVIEW: resetInterview,
    GET_INTERVIEW_COMPLETE: getInterview,
});

function buildIncomeInfo(personInfoScreening) {
    const income = personInfoScreening.income;
    const personId = personInfoScreening.personId;
    const incomeInfoArray = [];

    if (income == null) {
        return {
            personId: personId,
            doesReceiveIncome: false,
            incomes: [],
        };
    }

    if (income.employmentStatus.includes("Employed")) {
        for (var employer of income.employers) {
            incomeInfoArray.push({
                incomeType: "Salaries/Wages",
                nameOfEmployer: employer.employerName,
                frequency: employer.frequency,
                amount: employer.amount,
                averageHoursWorkedPerWeek: employer.averageHoursWorkedPerWeek,
                monthlyAmount: employer.monthlyAmount,
            });
        }
    }

    if (income.employmentStatus.includes("Self-employed")) {
        incomeInfoArray.push({
            incomeType: "Self Employed",
            typeOfWork: "typeOfWork",
            frequency: "Monthly",
            amount: income.selfEmployment.amount,
            monthlyAmount: income.selfEmployment.amount,
        });
    }

    for (const unearnedIncomeKey in income.unearned) {
        if (income.unearned.hasOwnProperty(unearnedIncomeKey)) {
            const value = income.unearned[unearnedIncomeKey];
            const incomeType = toPascalCase(unearnedIncomeKey);
            incomeInfoArray.push({
                incomeType: incomeType,
                frequency: value.frequency,
                amount: value.amount,
                monthlyAmount: value.monthlyAmount,
            });
        }
    }

    return {
        personId: personId,
        doesReceiveIncome: incomeInfoArray.length > 0,
        incomes: incomeInfoArray,
    };
}

function toPascalCase(string) {
    return `${string}`
        .replace(new RegExp(/[-_]+/, "g"), " ")
        .replace(new RegExp(/[^\w\s]/, "g"), "")
        .replace(new RegExp(/\s+(.)(\w+)/, "g"), ($1, $2, $3) => `${$2.toUpperCase() + $3.toLowerCase()}`)
        .replace(new RegExp(/\s/, "g"), "")
        .replace(new RegExp(/\w/), s => s.toUpperCase());
}
